module.exports = __webpack_public_path__ + "static/img/アセット 36@2x.ae23fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_history/アセット 36@2x.png
// module id = Qfhq
// module chunks = 1